<template>
  <div class="h-full relative overflow-hidden">
    <p v-show="isActive === false && isResults === false" class="h-full flex justify-center items-center">
      Participation inactive
    </p>

    <transition name="slide-in">
      <div
        v-if="currentTimer >= 0"
        class="w-full h-full absolute bg-red-700 z-10"
        :style="'transition-duration:' + timer + 's'"
      ></div>
    </transition>

    <div
      v-show="isActive === true"
      class="h-full flex justify-center items-center text-white font-normal"
      :class="[isOffline === true ? 'is-offline' : 'bg-green']"
    >
      <p v-show="currentTimer === -1 && attendees === 0">Participez !</p>
      <p v-show="currentTimer === -1 && attendees > 0">{{ attendees }} participants</p>
      <p v-show="currentTimer > 0 && attendees === 0" class="z-20">{{ currentTimer }} sec</p>
      <div v-show="currentTimer > 0 && attendees > 0" class="z-20 flex justify-between w-full px-2">
        <p>{{ attendees }} pax</p>
        <p>{{ currentTimer }} sec</p>
      </div>
      <p v-show="currentTimer === 0" class="z-20">Stop !</p>
    </div>

    <p v-show="isActive === false && isResults === true" class="h-full flex justify-center items-center">
      Résultats
    </p>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      isActive: (state) => state.live.isActive,
      timer: (state) => state.live.timer,
      currentTimer: (state) => state.live.currentTimer,
      isResults: (state) => state.live.isResults,
      attendees: (state) => state.question.attendees,
      isOffline: (state) => state.app.isOffline,
    }),
  },
}
</script>

<style>
.slide-in-enter-active {
  transition: all linear;
}
.slide-in-enter {
  transform: translateX(-160px);
}
.slide-in-leave-active {
  @apply hidden;
}
.is-offline {
  background: repeating-linear-gradient(45deg, #14bd15, #14bd15 10px, #c53030 10px, #c53030 20px);
}
</style>
